import { coreFollowsRoute } from '@/modules/library/domain/routes/libraryRoutes';
import { requestQuery } from '@/services/request';
import { DomainTypes } from '@/types';

export const addProgramFollow = async (programSource: DomainTypes, programUUID: string) =>
  requestQuery<void>({
    method: 'POST',
    url: coreFollowsRoute,
    data: {
      programId: programUUID,
      type: programSource === DomainTypes.Corporate ? DomainTypes.Corporate : DomainTypes.Internal,
    },
  });
